import axiosInstance from "../axiosInstance";

export const updatePackageStatus = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axiosInstance.post(
      `shipment/carrier/update-packages-status`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
